import type { GetMenuOfferingsResponse, UpsertMenuOfferingsBody } from '@bhops/shared';
import { apiClient } from './client';
import { downloadBlob } from './download';

export const menuOfferingsApi = {
  async getByStore(storeId: string): Promise<GetMenuOfferingsResponse> {
    const { data } = await apiClient.get<GetMenuOfferingsResponse>(
      `/stores/${storeId}/menu-offerings`,
    );
    return data;
  },

  async upsertMatrix(
    storeId: string,
    body: UpsertMenuOfferingsBody,
  ): Promise<GetMenuOfferingsResponse> {
    const { data } = await apiClient.put<GetMenuOfferingsResponse>(
      `/stores/${storeId}/menu-offerings`,
      body,
    );
    return data;
  },

  /**
   * Download the store's 31×7 MenuOffering matrix as a CSV.
   * Server-side filename takes precedence; the supplied fallback is used
   * only if the Content-Disposition header is missing or malformed.
   */
  async exportCsv(storeId: string): Promise<void> {
    await downloadBlob(
      `/stores/${storeId}/menu-offerings/export.csv`,
      undefined,
      `menu-offerings-${storeId}.csv`,
    );
  },

  /**
   * Download the store's 31×7 MenuOffering matrix as an Excel (.xlsx) workbook.
   * The workbook contains two sheets: "Matrix" (same columns as the CSV) and
   * "Meta" (storeId, generatedAt, schemaVersion). Server-side filename takes
   * precedence over the supplied fallback.
   */
  async exportXlsx(storeId: string): Promise<void> {
    await downloadBlob(
      `/stores/${storeId}/menu-offerings/export.xlsx`,
      undefined,
      `menu-offerings-${storeId}.xlsx`,
    );
  },
};
